<template>
  <VisionSearchSelect
    id="sidebar-country-select"
    name="sidebarCountrySelect"
    shape="rounded"
    :options="countries"
    @selected-option="
      ;(selectedOptionValue = $event), $emit('country-changed', $event)
    "
  />
</template>

<script>
export default {
  name: "CountrySelect",

  props: {
    defaultCountryCode: {
      type: String,
      default: "",
    },

    featuredCountryCodes: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["country-changed"],

  data() {
    return {
      selectedOptionValue: ''
    }
  },

  computed: {
    countries() {
      const featured = this.featuredCountryCodes
        .map((country) => ({
          ...this.$i18n.locales.find((c) => c.code === country),
          featured: true,
        }))
        .map((featuredCountry) => {
          return {
            displayValue: featuredCountry.countryName,
            value: featuredCountry.code,
            selected:
              featuredCountry.code ===
              (this.selectedOptionValue || this.$i18n.locale.value),
          }
        })
        .filter((country) => country === country)

      const all = [...this.$i18n.locales]
        .sort((a, b) => a.countryName.localeCompare(b.countryName))
        .map((country) => {
          return {
            displayValue: country.countryName,
            value: country.code,
            selected:
              country.code === (this.selectedOptionValue || this.$i18n.locale),
          }
        })

      const countryList = featured.length
        ? [
            ...featured,
            { displayValue: 'All countries', divider: true, selectable: false },
            ...all,
          ]
        : all

      return countryList
    },
  },
}
</script>
